import { FormGroup, InputV2, SelectInputV2Props } from '@southfields-digital/mxmz-react-ui';

type SportDataSelectProps = {
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: SelectInputV2Props['options'];
  value: string | number;
  label: string;
};

const SportDataSelect = ({ onChange, options, value, label }: SportDataSelectProps) => (
  <FormGroup label={label} htmlFor={label}>
    <InputV2
      type="select"
      inputSize="lg"
      id={label}
      value={value}
      options={options}
      onChange={onChange}
      // TODO: REMOVE THIS STYLING OVERRIDE WHEN ALL INPUTS USE INPUTV2
      wrapperClassName="!min-h-[42px] !rounded-[4px] !bg-elevated-0 !border-gray-800"
    />
  </FormGroup>
);

export default SportDataSelect;
